// extracted by mini-css-extract-plugin
export var errorIcon = "_oj-1";
export var nameLogo = "_oj-0";